/* Mont Glace — theme JS (Shopify OS 2.0)
   Cart AJAX, drawer, variant picker, menu, reveal, toast.
   SHËNIM: i pa-testuar ende kundrejt një dyqani real Shopify — s'ka dev store. */
(function () {
  'use strict';
  var MG = window.MontGlace || { routes: {}, strings: {}, moneyFormat: '{{amount}}' };
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- money (përdor money_format të dyqanit) ---------- */
  function money(cents) {
    var amount = (cents / 100).toFixed(2);
    return (MG.moneyFormat || '{{amount}}').replace(/\{\{\s*amount[^}]*\}\}/, amount);
  }

  /* ---------- toast ---------- */
  var toast = $('.toast');
  var tT;
  function say(msg) {
    if (!toast) return;
    $('span', toast).textContent = msg;
    toast.classList.add('show');
    clearTimeout(tT);
    tT = setTimeout(function () { toast.classList.remove('show'); }, 2800);
  }

  /* ---------- cart state ---------- */
  function updateBag(count) {
    $$('.bag__n').forEach(function (b) {
      b.textContent = count;
      if (b.animate) b.animate(
        [{ transform: 'scale(1)' }, { transform: 'scale(1.6)' }, { transform: 'scale(1)' }],
        { duration: 420 });
    });
  }

  function refreshCart(openDrawer) {
    return fetch(MG.routes.cart_url + '.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateBag(cart.item_count);
        renderDrawer(cart);
        if (openDrawer) toggleDrawer(true);
        return cart;
      });
  }

  function addToCart(id, qty) {
    return fetch(MG.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: qty || 1 })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    });
  }

  function changeLine(line, qty) {
    return fetch(MG.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  /* ---------- cart drawer ---------- */
  var drawer = $('.cdrawer');
  function toggleDrawer(open) {
    if (!drawer) return;
    drawer.classList.toggle('open', open);
    document.body.style.overflow = open ? 'hidden' : '';
    if (open) { var f = $('.cdrawer__panel', drawer); if (f) f.focus(); }
  }

  function renderDrawer(cart) {
    if (!drawer) return;
    var items = $('.cdrawer__items', drawer);
    var foot = $('.cdrawer__foot', drawer);
    if (!items) return;
    if (cart.item_count === 0) {
      items.innerHTML = '<div class="cdrawer__empty"><p>' + (drawer.dataset.emptyText || '') +
        '</p><a class="btn btn--sm" href="' + (drawer.dataset.allUrl || '/collections/all') +
        '"><span>' + (drawer.dataset.continueText || '') + '</span></a></div>';
      if (foot) foot.hidden = true;
      return;
    }
    if (foot) foot.hidden = false;
    items.innerHTML = cart.items.map(function (it, i) {
      var img = it.image ? it.image.replace(/(\.[a-z]{3,4})(\?|$)/, '_160x$1$2') : '';
      return '<div class="cline" data-line="' + (i + 1) + '">' +
        (img ? '<img class="cline__img" src="' + img + '" alt="" loading="lazy">' : '<span class="cline__img"></span>') +
        '<div><div class="cline__t">' + it.product_title + '</div>' +
        (it.variant_title && it.variant_title !== 'Default Title'
          ? '<div class="cline__v">' + it.variant_title + '</div>' : '') +
        '<div class="cline__qty">' +
        '<button type="button" data-dq aria-label="' + (drawer.dataset.decText || '-') + '">−</button>' +
        '<input inputmode="numeric" value="' + it.quantity + '" data-qi aria-label="' + (drawer.dataset.qtyText || 'qty') + '">' +
        '<button type="button" data-iq aria-label="' + (drawer.dataset.incText || '+') + '">+</button></div>' +
        '<a href="#" class="cline__rm" data-rm>' + (drawer.dataset.removeText || '×') + '</a></div>' +
        '<div class="cline__price">' + money(it.final_line_price) + '</div></div>';
    }).join('');
    var sub = $('[data-subtotal]', drawer);
    if (sub) sub.textContent = money(cart.items_subtotal_price);
    // free shipping bar
    var bar = $('.fs-bar i', drawer), note = $('.fs-note', drawer);
    var threshold = parseFloat(drawer.dataset.fsThreshold || '0') * 100;
    if (bar && threshold > 0) {
      var pct = Math.min(100, cart.items_subtotal_price / threshold * 100);
      bar.style.width = pct + '%';
      if (note) note.textContent = pct >= 100
        ? drawer.dataset.fsReached
        : (drawer.dataset.fsRemaining || '').replace('[amount]', money(threshold - cart.items_subtotal_price));
    }
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-cart-open]')) { e.preventDefault(); refreshCart(true); }
    if (t.closest('[data-cart-close]') || t.classList.contains('cdrawer__bg')) toggleDrawer(false);
    var line = t.closest('.cline');
    if (line) {
      var n = parseInt(line.dataset.line, 10);
      var qi = $('[data-qi]', line);
      var q = parseInt(qi.value, 10) || 1;
      if (t.closest('[data-dq]')) changeLine(n, Math.max(0, q - 1)).then(function (c) { updateBag(c.item_count); renderDrawer(c); });
      if (t.closest('[data-iq]')) changeLine(n, q + 1).then(function (c) { updateBag(c.item_count); renderDrawer(c); });
      if (t.closest('[data-rm]')) { e.preventDefault(); changeLine(n, 0).then(function (c) { updateBag(c.item_count); renderDrawer(c); }); }
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { toggleDrawer(false); toggleMenu(false); }
  });

  /* ---------- quick add (product cards) ---------- */
  $$('[data-quick-add]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var id = parseInt(b.dataset.quickAdd, 10);
      if (!id) return;
      b.disabled = true;
      addToCart(id, 1)
        .then(function () { say(MG.strings.addedToCart); return refreshCart(false); })
        .catch(function (err) { say((err && err.description) || MG.strings.cartError); })
        .then(function () { b.disabled = false; });
    });
  });

  /* ---------- wishlist (localStorage, i përkohshëm — pa backend, pa rrjet) ---------- */
  var WISH_KEY = 'mg:wishlist:v1';
  function wishRead() {
    try {
      var arr = JSON.parse(window.localStorage.getItem(WISH_KEY) || '[]');
      return Array.isArray(arr) ? arr : [];
    } catch (err) { return []; }
  }
  function wishWrite(list) {
    try { window.localStorage.setItem(WISH_KEY, JSON.stringify(list)); }
    catch (err) { /* storage i bllokuar (private mode) — gjendja mbetet vetëm në faqe */ }
  }
  function wishApply(btn, saved) {
    btn.classList.toggle('on', saved);
    btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
  }
  $$('[data-wishlist]').forEach(function (b) {
    var h = b.dataset.handle;
    if (!h) return;
    wishApply(b, wishRead().indexOf(h) > -1);
    b.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      // gjendja ndiqet nga UI — storage është vetëm persistencë best-effort
      var saved = !b.classList.contains('on');
      var list = wishRead();
      var i = list.indexOf(h);
      if (saved && i === -1) list.push(h);
      if (!saved && i > -1) list.splice(i, 1);
      wishWrite(list);
      wishApply(b, saved);
      say(saved ? b.dataset.msgOn : b.dataset.msgOff);
    });
  });

  /* ---------- chips filtrimi i kategorive (homepage) ---------- */
  $$('.chip[data-f]').forEach(function (c) {
    c.addEventListener('click', function () {
      var scope = c.closest('.sec') || document;
      $$('.chip[data-f]', scope).forEach(function (o) {
        o.classList.toggle('on', o === c);
        o.setAttribute('aria-pressed', o === c ? 'true' : 'false');
      });
      var f = c.dataset.f;
      $$('.grid .card', scope).forEach(function (card) {
        var cats = (card.dataset.cats || '').split(' ');
        card.style.display = (f === 'all' || cats.indexOf(f) > -1) ? '' : 'none';
      });
    });
  });

  /* ---------- mobile menu ---------- */
  var mm = $('.mmenu');
  function toggleMenu(open) {
    if (!mm) return;
    var willOpen = open === undefined ? !mm.classList.contains('open') : open;
    mm.classList.toggle('open', willOpen);
    document.body.style.overflow = willOpen ? 'hidden' : '';
    $$('[data-menu-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', willOpen); });
  }
  $$('[data-menu-toggle]').forEach(function (b) {
    b.addEventListener('click', function () { toggleMenu(); });
  });

  /* ---------- language switcher (localization form) ---------- */
  $$('[data-lang-select]').forEach(function (s) {
    s.addEventListener('change', function () {
      var f = s.closest('form');
      if (f) f.submit();
    });
  });

  /* ---------- header shadow ---------- */
  var hdr = $('.hdr');
  window.addEventListener('scroll', function () {
    if (hdr) hdr.style.boxShadow = window.scrollY > 12 ? '0 6px 26px rgba(8,10,12,.08)' : 'none';
  }, { passive: true });

  /* ---------- scroll reveal ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.12 });
    $$('.rv').forEach(function (el) { io.observe(el); });
  } else {
    $$('.rv').forEach(function (el) { el.classList.add('in'); });
  }

  /* ---------- accordion ---------- */
  $$('.acc__h').forEach(function (h) {
    h.addEventListener('click', function () {
      var item = h.parentElement, p = $('.acc__p', item), open = item.classList.contains('open');
      $$('.acc__i', item.parentElement).forEach(function (o) {
        o.classList.remove('open');
        $('.acc__p', o).style.maxHeight = null;
        $('.acc__h', o).setAttribute('aria-expanded', 'false');
      });
      if (!open) {
        item.classList.add('open');
        p.style.maxHeight = p.scrollHeight + 'px';
        h.setAttribute('aria-expanded', 'true');
      }
    });
  });
  var firstAcc = $('.acc__i');
  if (firstAcc) {
    firstAcc.classList.add('open');
    var fp = $('.acc__p', firstAcc);
    if (fp) fp.style.maxHeight = fp.scrollHeight + 'px';
    var fh = $('.acc__h', firstAcc);
    if (fh) fh.setAttribute('aria-expanded', 'true');
  }

  /* ---------- PDP: variant picker ---------- */
  var pform = $('[data-product-form]');
  if (pform) {
    var pjson = $('[data-product-json]');
    var pdata = null;
    try { pdata = pjson ? JSON.parse(pjson.textContent) : null; }
    catch (err) { pdata = null; /* JSON i dëmtuar — picker-i mbetet me gjendjen e server-it */ }
    var buyBtns = $$('[data-buy]');
    var priceEl = $('[data-price]');
    var cmpEl = $('[data-compare-price]');
    var idInput = $('[name="id"]', pform);

    function selectedOptions() {
      return $$('fieldset[data-option]', pform).map(function (fs) {
        var on = $('input:checked', fs);
        return on ? on.value : null;
      });
    }
    function findVariant(opts) {
      return pdata.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    function updateOptionLabels() {
      $$('fieldset[data-option]', pform).forEach(function (fs) {
        var em = $('[data-selected]', fs);
        if (!em) return;
        var on = $('input:checked', fs);
        if (on) em.textContent = on.value;
      });
    }
    // .on ndjek gjithmonë inputin :checked (më parë vendosej vetëm nga serveri)
    function syncSelectedClasses() {
      $$('fieldset[data-option]', pform).forEach(function (fs) {
        $$('label', fs).forEach(function (l) {
          var inp = $('input', l);
          if (inp) l.classList.toggle('on', inp.checked);
        });
      });
    }
    // available / sold-out (.out) / kombinim inekzistent (.off + disabled, pa auto-ripërshtatje)
    function updateAvailability() {
      if (!pdata) return;
      var opts = selectedOptions();
      $$('fieldset[data-option]', pform).forEach(function (fs) {
        var idx = parseInt(fs.dataset.optionIndex, 10);
        $$('label', fs).forEach(function (l) {
          var inp = $('input', l);
          if (!inp) return;
          var test = opts.slice();
          test[idx] = inp.value;
          var matches = pdata.variants.filter(function (v) {
            return v.options.every(function (o, i) { return test[i] === null || o === test[i]; });
          });
          var exists = matches.length > 0;
          var avail = matches.some(function (v) { return v.available; });
          inp.disabled = !exists;
          l.classList.toggle('off', !exists);
          l.classList.toggle('out', exists && !avail);
        });
      });
    }
    function updateVariant() {
      updateOptionLabels();
      syncSelectedClasses();
      updateAvailability();
      if (!pdata) return;
      var opts = selectedOptions();
      if (opts.some(function (o) { return o === null; })) return;
      var v = findVariant(opts);
      buyBtns.forEach(function (b) {
        var span = $('span', b) || b;
        if (!v) { b.disabled = true; span.textContent = MG.strings.unavailable; }
        else if (!v.available) { b.disabled = true; span.textContent = MG.strings.soldOut; }
        else { b.disabled = false; span.textContent = MG.strings.addToCart; }
      });
      if (v) {
        idInput.value = v.id;
        if (priceEl) priceEl.textContent = money(v.price);
        if (cmpEl) cmpEl.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : '';
        if (window.history.replaceState) {
          var u = new URL(location.href); u.searchParams.set('variant', v.id);
          history.replaceState({}, '', u);
        }
        // media sipas ngjyrës (alt-teksti i medias == emri i ngjyrës)
        var colorIdx = pdata.options.findIndex(function (o) { return /color|ngjyr/i.test(o); });
        if (colorIdx > -1) switchGalleryColor(v.options[colorIdx]);
        // 3D ngjyrat nga metafield (nëse janë)
        if (window.__mg3d && pform.dataset.colors3d) {
          try {
            var map = JSON.parse(pform.dataset.colors3d);
            var c = map[v.options[colorIdx]];
            if (c && c.length === 3) window.__mg3d.setColors(c[0], c[1], c[2]);
          } catch (err) { /* metafield bosh — ok */ }
        }
      }
    }
    $$('fieldset[data-option] input', pform).forEach(function (r) {
      r.addEventListener('change', updateVariant);
    });
    // gjendja fillestare e swatch-eve (pa e prekur URL-në)
    syncSelectedClasses();
    updateAvailability();

    pform.addEventListener('submit', function (e) {
      e.preventDefault();
      var id = parseInt(idInput.value, 10);
      if (!id) { say(MG.strings.chooseSize); return; }
      addToCart(id, 1)
        .then(function () { say(MG.strings.addedToCart); return refreshCart(true); })
        .catch(function (err) { say((err && err.description) || MG.strings.cartError); });
    });

    /* galeria */
    function switchGalleryColor(color) {
      var found = false;
      $$('.thumb[data-color]').forEach(function (t) {
        var match = t.dataset.color === color;
        t.hidden = t.dataset.color && !match && $$('.thumb[data-color="' + color + '"]').length > 0;
        if (match && !found) { t.click(); found = true; }
      });
    }
    $$('.thumb[data-media]').forEach(function (t) {
      t.addEventListener('click', function () {
        $$('.thumb').forEach(function (o) { o.classList.remove('on'); });
        t.classList.add('on');
        var img = $('.stage__img');
        if (img && t.dataset.src) { img.src = t.dataset.src; img.srcset = t.dataset.srcset || ''; }
        if (window.__mg3dToggle) window.__mg3dToggle(false);
      });
    });

    /* sticky buy */
    var sticky = $('.sticky-buy'), buyBox = $('.buy');
    if (sticky && buyBox && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        sticky.classList.toggle('show', !es[0].isIntersecting);
      }, { threshold: 0 }).observe(buyBox);
    }
  }

  /* ---------- newsletter (Shopify customer form) ---------- */
  $$('form[action*="contact"] , form.form').forEach(function (f) {
    // suksesi tregohet nga Shopify me query param
  });
  if (location.search.indexOf('customer_posted=true') > -1) {
    say((window.MontGlace.strings && MG.strings.newsletterSuccess) || '');
  }

  /* ---------- init ---------- */
  refreshCart(false).catch(function () { /* offline / pa store — ok në dev */ });
})();
